module.exports = __webpack_public_path__ + "img/logo.f13b6508.png";